export enum SmokerServerValues {
  SMOKER = 'RAUCHER',
  NON_SMOKER_MORE_THAN_10 = 'NICHTRAUCHER_SEIT_10_JAHREN',
  NON_SMOKER_AT_LEAST_A_YEAR = 'NICHTRAUCHER_SEIT_12_MONATEN',
}
